import React from 'react';
import { func } from 'prop-types';
import {
  Fab,
} from '@one-thd/sui-atomic-components';
import { useImpression, ImpressionProvider } from '@thd-olt-component-react/impression';
import { AssistantIcon } from '../../../assets/AssistantIcon';
import { getPageType, getItemId } from '../../../utils/assistant-context-utils';

export const AssistantFAB = ({ onClick }) => {
  const pageType = getPageType();
  const getImpressionId = () => {
    switch (pageType) {
    case 'PIP':
      return getItemId();
    case 'Content': // TODO: If applicable capture Contentful ID, otherwise return default
    default:
      return '00DEFVALMA00';
    }
  };

  const impressionData = {
    id: 'MagicApronAssistant',
    name: 'MagicApronAssistant',
    component: 'MagicApronAssistant',
    type: 'content',
  };
  const { ref, clickID } = useImpression({ data: {
    component: 'MagicApronAssistant',
    id: getImpressionId(),
    name: 'MagicApronAssistant',
    type: 'content',
    position: '',
  } });

  return (
    <ImpressionProvider data={impressionData}>
      <Fab
        aria-label="Assistant FAB"
        onClick={onClick}
        ref={ref}
        clickid={clickID}
      >
        <AssistantIcon color="inverse" />
      </Fab>
    </ImpressionProvider>
  );
};

AssistantFAB.propTypes = {
  onClick: func.isRequired,
};
